import { Bank, LocalAuthority } from "../../model"
import { genericFetch } from "./common-service"
import { apiBaseUrl } from "./config"
import { getBaseHeader } from "./utils"

const BANKS = 'banks'
const LOCALAUTHORITIES = 'localauthorities'

export function findBanksByLocalAuthority(localAuthority: LocalAuthority): Promise<Bank[]> {
	const url: string = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.id}/${BANKS}`

	return genericFetch<Bank[]>(url, { headers: getBaseHeader() })
}


// WEBPACK FOOTER //
// ./src/service/sfp/banks-service.ts